import moment from 'moment-timezone';

const dateFormatter = (date) => {
   return moment(String(date)).format('DD-MM-YYYY, HH:mm:ss');
}

export default dateFormatter;


// WEBPACK FOOTER //
// ./src/components/utilities/dateFormate.js